/** Stable window name so a second View Details reuses the same tab. */
export function assessmentPackWindowName(detailUrl: string): string {
  let hash = 0;
  for (let index = 0; index < detailUrl.length; index += 1) {
    hash = (Math.imul(31, hash) + detailUrl.charCodeAt(index)) | 0;
  }
  return `griAssessmentPack${(hash >>> 0).toString(36)}`;
}
